<div mat-dialog-title class="d-flex justify-content-end align-items-center">
  <button
    data-automation-id="dialog-close-button"
    mat-icon-button
    [mat-dialog-close]="true"
    aria-label="Close Inactivity Warning dialog and stay signed in"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <p>
    Your session will expire in {{ countdown }} minutes.
    <br />
    Do you want to stay signed in?
  </p>

  <div class="dialog-footer">
    <button
      data-automation-id="generic-logout-warning-dialog_202130142452"
      type="button"
      mat-flat-button
      color="primary"
      [mat-dialog-close]="true"
    >
      Yes, keep me signed in
    </button>
    <button
      data-automation-id="generic-logout-warning-dialog_202130142456"
      type="button"
      mat-flat-button
      [mat-dialog-close]="false"
      [routerLink]="['/logout']"
      [queryParams]="{ doLogout: true, force: true }"
    >
      No, sign me out
    </button>
  </div>
</mat-dialog-content>
